module.exports = __webpack_public_path__ + "img/dial-bg.dcc88dec.png";